import Vue from 'vue'

// Might want to change it to UUID
const indexBy = 'id'

const mutations = {
  SET (state, groups = []) {
    state.groups = {}
    groups.forEach(group => {
      Vue.set(state.groups, group[indexBy], group)
    })
  },

  // Add new group to store
  ADD (state, group) {
    Vue.set(state.groups, group[indexBy], group)
  },

  // Remove group from store
  REMOVE (state, key) {
    Vue.delete(state.groups, key)
  },

  SET_NEW (state, id) {
    state.newGroup = state.groups[id]
  },

  UPDATE_NEW ({ newGroup }, { key, value }) {
    newGroup[key] = value
  },

  CLEAR_NEW (state) {
    state.newGroup = {
      slug: ''
    }
  }
}

export default mutations
